import { configureStore } from '@reduxjs/toolkit';
import configReducer from './configSlice';
import loginReducer from '../login/loginSlice';
import tokenReducer from '../tokenHandling/tokenSlice';
import apiReducer from '../../features/app/api/redux/api.redux';
import { packageActivationApiSlice } from '../../features/app/api/packageActivation/packageActivationApiSlice';
import { contractApiSlice } from '../../features/app/api/contract/contractApiSlice';
import { activationApiSlice } from '../../features/app/api/activation/activationApiSlice';
import { mergedActivationApiSlice } from '../../features/app/api/activation/mergedActivationApiSlice';
import { paymentApiSlice } from '../../features/app/api/billing/paymentApiSlice';
import { bookingIntentApiSlice } from '../../features/app/api/bookingIntent/bookingIntentApiSlice';
import { freeTrialApiSlice } from '../../features/app/api/freetrial/freeTrialApiSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        api: apiReducer,
        [packageActivationApiSlice.reducerPath]: packageActivationApiSlice.reducer,
        [contractApiSlice.reducerPath]: contractApiSlice.reducer,
        [activationApiSlice.reducerPath]: activationApiSlice.reducer,
        [mergedActivationApiSlice.reducerPath]: mergedActivationApiSlice.reducer,
        [paymentApiSlice.reducerPath]: paymentApiSlice.reducer,
        [bookingIntentApiSlice.reducerPath]: bookingIntentApiSlice.reducer,
        [freeTrialApiSlice.reducerPath]: freeTrialApiSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware()
            .concat(packageActivationApiSlice.middleware)
            .concat(contractApiSlice.middleware)
            .concat(activationApiSlice.middleware)
            .concat(mergedActivationApiSlice.middleware)
            .concat(paymentApiSlice.middleware)
            .concat(bookingIntentApiSlice.middleware)
            .concat(freeTrialApiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
